export const apiVariable = process.env.REACT_APP_API_URL;

export const functionAppUrlVariable = process.env.REACT_APP_FUNCTION_APP_URL;
export const generateRepairReportFunctionKey =
  process.env.REACT_APP_GENERATE_REPAIR_REPORT_FUNCTION_KEY;
export const generateMaintenancePerMileReportFunctionKey =
  process.env.REACT_APP_GENERATE_MAINTENANCE_PER_MILE_REPORT_FUNCTION_KEY;
export const generateAllRepairReportFunctionKey =
  process.env.REACT_APP_GENERATE_ALL_REPAIR_REPORT_FUNCTION_KEY;
export const generateMaintenanceReportFunctionKey =
  process.env.REACT_APP_GENERATE_MAINTENANCE_REPORT_FUNCTION_KEY;
